export const GARANSI_BANNER_HIDDEN_KEY = 'garansi-notif-hidden';

/**
 * The banner hides for the current session only. Call this whenever the user
 * signs out so the next login starts with a visible banner (FR-11.6 / P-24).
 */
export function clearGaransiBannerHidden(): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(GARANSI_BANNER_HIDDEN_KEY);
}
